import { Controller } from "@hotwired/stimulus"
import { Player } from "../player"

// Connects to data-controller="player"
export default class extends Controller {
  static values = {
    playerDomId: { type: String, default: "audio-player" }
  };

  // For some reason, this is being connected before the DOM is ready,
  // specifically the audio-player which is in a turbo permanent div.
  // So we need to check if the player is there, and if not, wait for
  // the turbo:render event to fire, and then try again.
  connect() {
    if (this.mayConnectPlayer()) {
      this.connectPlayer();
    } else {
      const _self = this;
      document.addEventListener("turbo:render", tryToConnectPlayer);
      function tryToConnectPlayer(event) {
        document.removeEventListener("turbo:render", tryToConnectPlayer);
        _self.connect();
      }
    }
  }

  mayConnectPlayer() {
    return document.getElementById(this.playerDomIdValue);
  }

  connectPlayer() {
    this.player = new Player(this.playerDomIdValue);
  }

  play(ev) {
    ev.preventDefault();
    this.showPlayerBox();
    this.unsetPlayingRow(ev.target);
    this.setPlayingRow(ev.target);
    this.player.play_or_pause(ev.params.audioUrl, ev.params.title, ev.params.waveformUrl);
  }

  stop(ev) {
    ev.preventDefault();
    this.unsetPlayingRow(ev.target);
    this.player.stop_playing();
  }

  setPlayingRow(play_button) {
    // Support both table rows and list items
    const row_el = play_button.closest('tr') || play_button.closest('li');
    if (row_el) {
      row_el.classList.add('playing');
    }
  }

  unsetPlayingRow(button) {
    // Remove playing class from all elements on the page
    document.querySelectorAll('.playing').forEach(function(el) {
      el.classList.remove('playing');
    });
  }

  showPlayerBox() {
    const playerBox = document.getElementById('playerBox');
    if (playerBox) {
      playerBox.style.display = '';
    }
  }

  hidePlayerBox() {
    const playerBox = document.getElementById('playerBox');
    if (playerBox) {
      playerBox.style.display = 'none';
    }
  }
}
